module.exports = __webpack_public_path__ + "static/media/banner-grupotrimex.59f8fc87.jpg";